<template>
  <div id="canvas">
    <TresCanvas
      clear-color="#000000"
      ref="refRoot"
      window-resize
      :toneMappingExposure="1"
      :toneMapping="NoToneMapping"
      :multisampling="8"
    >
      <!-- 
      :output-encoding="sRGBEncoding" -->
      <!-- <FsTriangleCamera /> -->
      <ScreenCamera />
      <ColorAdjustment />
      <!-- <TresPerspectiveCamera /> -->

      <Suspense>
        <FlowMap
          :size="flowMapSize"
          :falloff="flowMapFalloff"
          :dissipation="flowMapDissipation"
        >
          <Dots />

          <!-- <DotsMap2 v-if="route.path == '/contact'" /> -->
          <DotsMap2 />

          <TresGroup
            name="cards"
            render-order="30"
          >
            <DotsCardThree
              v-for="(card, idx) in app.cards"
              :cardId="card"
              :idx="idx"
              :key="card"
            />
          </TresGroup>
        </FlowMap>
      </Suspense>

      <!-- <ToneMappingPmndrs :mode="toneMappingMode" /> -->
      <!-- <EffectComposerPmndrs>
        <BloomPmndrs
          :radius="bloomRadius"
          :intensity="bloomIntensity"
          :luminance-threshold="bloomLuminanceThreshold"
          :luminance-smoothing="bloomLuminanceSmoothing"
          :mipmap-blur="true"
        />
      </EffectComposerPmndrs> -->
    </TresCanvas>
  </div>
</template>

<script setup lang="ts">
import {
  BloomPmndrs,
  EffectComposerPmndrs,
  ToneMappingPmndrs,
} from "@tresjs/post-processing"
import { ToneMappingMode } from "postprocessing"
import { ColorManagement } from "three"
ColorManagement.enabled = true

import fsTriangle from "./fsTriangle"

const props = defineProps({})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

const route = useRoute()

const {
  //
  flowMapSize,
  flowMapFalloff,
  flowMapDissipation,
  flowMapStrength,
} = useDots()

const bloomRadius = ref(0.85)
const bloomIntensity = ref(3.0)
const bloomLuminanceThreshold = ref(1.0)
const bloomLuminanceSmoothing = ref(0.3)
const toneMappingMode = ref(ToneMappingMode.AGX)

useDotsPane()

usePane(
  [
    {
      name: "Radius",
      value: bloomRadius,
      options: {
        min: 0,
        max: 1,
        step: 0.01,
      },
    },
    {
      name: "Intensity",
      value: bloomIntensity,
      options: {
        min: 0,
        max: 10,
        step: 0.1,
      },
    },
    {
      name: "Luminance Threshold",
      value: bloomLuminanceThreshold,
      options: {
        min: 0,
        max: 2,
        step: 0.01,
      },
    },
    {
      name: "Luminance Smoothing",
      value: bloomLuminanceSmoothing,
      options: {
        min: 0,
        max: 1,
        step: 0.01,
      },
    },
    {
      name: "Tone Mapping",
      value: toneMappingMode,
      options: {
        LINEAR: ToneMappingMode.LINEAR,
        REINHARD: ToneMappingMode.REINHARD,
        REINHARD2: ToneMappingMode.REINHARD2,
        REINHARD2_ADAPTIVE: ToneMappingMode.REINHARD2_ADAPTIVE,
        UNCHARTED2: ToneMappingMode.UNCHARTED2,
        OPTIMIZED_CINEON: ToneMappingMode.OPTIMIZED_CINEON,
        CINEON: ToneMappingMode.CINEON,
        ACES_FILMIC: ToneMappingMode.ACES_FILMIC,
        AGX: ToneMappingMode.AGX,
        NEUTRAL: ToneMappingMode.NEUTRAL,
      },
    },
  ],
  {
    title: "Bloom",
    expanded: true,
  }
)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

#canvas {
  position: fixed;
  top: 0;
  left: 0;
  height: 100lvh;
  width: 100%;
  z-index: -2;
  pointer-events: none;
}

:deep(canvas) {
  pointer-events: none !important;
}
</style>
